// T0 — Tokens centralisés du design system (source unique de vérité visuelle).
// Couleurs/icônes par MODULE, par TYPE D'AGENT, par STATUT et par CRITICITÉ.
// Réutilisés par les composants doc/ et par toutes les pages -> homogénéisation.
// Les noms d'icônes correspondent aux exports de `lucide-react` (résolus via components/ui/Icon.js).

export const MODULES = {
  ENVIRONMENT: { key: 'ENVIRONMENT', label: 'Environnement', color: '#10B981', icon: 'Globe' },
  CAMPAIGN:    { key: 'CAMPAIGN',    label: 'Campagne',      color: '#F59E0B', icon: 'Target' },
  PERFORMANCE: { key: 'PERFORMANCE', label: 'Performances',  color: '#EF4444', icon: 'TrendingUp' },
  TRANSVERSE:  { key: 'TRANSVERSE',  label: 'Transverse',    color: '#3B82F6', icon: 'Layers' },
};

// 1 entrée par type d'agent supporté par le produit (cf. AgentType.java).
export const AGENT_TYPES = {
  GENERO_GDC:       { label: 'Genero GDC',  icon: 'MonitorSmartphone', color: '#8B5CF6', protocols: ['GDC', 'TCP'] },
  GENERO_GAS:       { label: 'Genero GAS',  icon: 'Server',            color: '#7C3AED', protocols: ['HTTP'] },
  DATABASE_ORA:     { label: 'Oracle',      icon: 'Database',          color: '#F97316', protocols: ['TNS', 'SQL'] },
  DATABASE_IFX:     { label: 'Informix',    icon: 'Database',          color: '#06B6D4', protocols: ['SQLI', 'SQL'] },
  DATABASE_POSTGRES:{ label: 'PostgreSQL',  icon: 'Database',          color: '#3B82F6', protocols: ['SQL'] },
  API_REST:         { label: 'API REST',    icon: 'Globe',             color: '#10B981', protocols: ['HTTP', 'HTTPS', 'REST'] },
  API_SOAP:         { label: 'API SOAP',    icon: 'Globe',             color: '#059669', protocols: ['SOAP', 'HTTPS'] },
  OS_LINUX:         { label: 'OS Linux',    icon: 'Terminal',          color: '#EAB308', protocols: ['SSH'] },
  OS_WINDOWS:       { label: 'OS Windows',  icon: 'SquareTerminal',    color: '#2563EB', protocols: ['WinRM', 'RDP'] },
  WEB_BROWSER:      { label: 'Web Browser', icon: 'AppWindow',         color: '#EC4899', protocols: ['WebDriver', 'HTTP'] },
};

export const STATUS = {
  published:  { label: 'Publié',    color: '#10B981' },
  draft:      { label: 'Brouillon', color: '#F59E0B' },
  deprecated: { label: 'Déprécié',  color: '#EF4444' },
  active:     { label: 'Actif',     color: '#10B981' },
  warning:    { label: 'Attention', color: '#F59E0B' },
  error:      { label: 'Erreur',    color: '#EF4444' },
};

export const CRITICALITY = {
  P0: { label: 'P0 — Bloquant',  color: '#EF4444' },
  P1: { label: 'P1 — Important', color: '#F59E0B' },
  P2: { label: 'P2 — Confort',   color: '#10B981' },
};

export const moduleOf = (key) => MODULES[key] || MODULES.TRANSVERSE;
export const agentOf = (key) => AGENT_TYPES[key] || null;
